module.exports = __webpack_public_path__ + "img/services-icon5.1b9ffcf7.png";